import { Target } from 'components/features/target-achievement-support/utils/type';
import React, { PropsWithChildren, useContext } from 'react';

// memo: startDateとendDateの形式はyyyy/MM/dd
type TargetAchievementSupportContextType = {
  isFirstFlg: boolean;
  updateIsFirstFlg: (data: boolean) => void;
  globalTarget: Target | null;
  updateGlobalTarget: (data: Target | null) => void;
  confirmGlobalTarget: Target | null;
  updateConfirmGlobalTarget: (data: Target | null) => void;
};

const TargetAchievementSupportContext = React.createContext<
  TargetAchievementSupportContextType
>({
  isFirstFlg: false,
  updateIsFirstFlg: () => {
    return;
  },
  globalTarget: null,
  updateGlobalTarget: () => {
    return;
  },
  confirmGlobalTarget: null,
  updateConfirmGlobalTarget: () => {
    return;
  },
});

export const TargetAchievementSupportProvider = (
  props: PropsWithChildren<Record<string, unknown>>
): React.ReactElement => {
  const [isFirstFlg, setIsFirstFlg] = React.useState<boolean>(false);

  const updateIsFirstFlg: TargetAchievementSupportContextType['updateIsFirstFlg'] = data => {
    setIsFirstFlg(data);
  };

  const [globalTarget, setGlobalTarget] = React.useState<Target | null>(null);

  const updateGlobalTarget: TargetAchievementSupportContextType['updateGlobalTarget'] = data => {
    setGlobalTarget(data);
  };

  const [
    confirmGlobalTarget,
    setConfirmGlobalTarget,
  ] = React.useState<Target | null>(null);

  const updateConfirmGlobalTarget: TargetAchievementSupportContextType['updateConfirmGlobalTarget'] = data => {
    setConfirmGlobalTarget(data);
  };

  return (
    <>
      <TargetAchievementSupportContext.Provider
        value={{
          isFirstFlg,
          updateIsFirstFlg,
          globalTarget,
          updateGlobalTarget,
          confirmGlobalTarget,
          updateConfirmGlobalTarget,
        }}>
        {props.children}
      </TargetAchievementSupportContext.Provider>
    </>
  );
};

export const useTargetAchievementSupportContext = (): TargetAchievementSupportContextType => {
  const context = useContext(TargetAchievementSupportContext);

  return context;
};
